import {ViewsCount} from "./ViewsCount";

export class ViewsCountPerDayDTO extends ViewsCount{
    date: string;

    constructor(json: any) {
        super(json);
        this.date = json.date;
    }
}